module.exports = __webpack_public_path__ + "img/calendar-w.5bc8b491.svg";